import React, { Fragment, useEffect, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useDispatch, useSelector } from "react-redux";
import { openModal } from "../../Redux/Slice/LoginSlice";
import CallTimeComponent from "../CallTimeComponent/CallTimeComponent";
import CallLogTable from "../CallLogTable/CallLogTable";
import { IconSquareX } from "@tabler/icons-react";

export default function ModifyCallTimeModal({ filterRecords }) {
  const modalState = useSelector((state) => state?.login);
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("call");

  useEffect(() => {
    if (modalState.isOpenModal) {
      setActiveTab("call");
    }
  }, [modalState.isOpenModal]);

  const isBlocked = modalState.startingTime && !modalState.endingTime
    || (modalState.startingTime && modalState.endingTime);


  const handleClose = () => {
    if (isBlocked) return;
    dispatch(openModal({ isOpenModal: false, modalData: null }));
  };

  return (
    <Transition appear show={modalState.isOpenModal} as={Fragment}>
      <Dialog as="div" className="relative z-[400]" onClose={() => { }}>
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm" />

        <div className="fixed inset-0 flex items-center justify-center p-4">
          <Dialog.Panel className="w-full max-w-7xl h-[110vh] bg-white rounded-2xl shadow-2xl overflow-hidden flex flex-col">

            {/* Header */}
            <div className="bg-base-color px-6 py-2 flex justify-between items-center">
              <h2 className="text-white text-xl font-bold">Call Time Tracker</h2>
              {!isBlocked && (
                <button onClick={handleClose}>
                  <IconSquareX stroke={1.5} size={23} color="#fff"/>
                </button>
              )}
            </div>

            {/* Tabs */}
            <div className="px-4">
              <div className=" flex justify-evenly border-b border-gray-300">
               <div className={`flex justify-center w-1/2 ${activeTab === "call" ? "border-b-2 border-base-color" : ""}`}>
                  <button
                    onClick={() => setActiveTab("call")}
                    className={`px-4  text-sm md:text-base font-medium
                    ${activeTab === "call"
                        ? "text-base-color"
                        : "text-gray-500 hover:text-base-color"}
                  `}
                  >
                    <span className="text-lg">Call Time</span>
                  </button>
               </div>
                <div className={`flex justify-center w-1/2 ${activeTab === "logs" ? "border-b-2 border-base-color" : ""}`}>
                  <button
                    onClick={() => setActiveTab("logs")}
                    className={`px-4 py-2 text-sm md:text-base font-medium
                    ${activeTab === "logs"
                        ? "text-base-color"
                        : "text-gray-500 hover:text-base-color"}
                  `}
                  >
                    <span className="text-lg">Call Logs</span>
                  </button>
                </div>
              </div>
            </div>

            {/* Body */}
            <div className="flex-1 overflow-y-auto px-4 py-2">
              <div className={activeTab === "call" ? "block" : "hidden"}>
                <CallTimeComponent filterRecords={filterRecords} />
              </div>

              <div className={activeTab === "logs" ? "block" : "hidden"}>
                <CallLogTable />
              </div>
            </div>

          </Dialog.Panel>
        </div>
      </Dialog>
    </Transition>
  );

}